export default "/fonts/vendor/katex/dist/KaTeX_Main-Bold.ttf?8169508bf58f8bd92ad8a768ede68a18";